import { createSlice } from "@reduxjs/toolkit";

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        message: null, isAlertOpen: false,type:null
    },
    reducers: {
        setAlert: (state, action) => {
            return { ...state, ...action.payload }
        }
    }
})

export const {setAlert} = alertSlice.actions;
export default alertSlice.reducer